export default __webpack_public_path__ + "static/media/homered.dcfb79cf.jpg";